
import { ellipsisString } from "@/app/infrastructures/misc/Utils";
import { AccountController } from "@/app/ui/controllers/AccountController";
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { STIController } from "@/app/ui/controllers/STIController";
import generateSummaryManifest from "@/app/ui/modules/summary";
import { Vue } from "vue-class-component";
import generateManifest, {
  generateManifestAndManifestNeedToSti,
  generateManifestNeedToSti
} from "./manifest-pdf-reverse-scan";
import formatDate from "@/app/infrastructures/misc/common-library/v2/FormatDate";
import en from "@/i18n/locales/en";
import id from "@/i18n/locales/id";
import my from "@/i18n/locales/my";
import { createI18n } from "vue-i18n";

function buildSummaryFields(dataHead: any) {
  const i18nInstance = createI18n({
    legacy: false,
    locale:
      AccountController.accountData.account_type_detail.countryCode.toLowerCase(),
    fallbackLocale: "id",
    globalInjection: false,
    messages: { en, id, my }
  });
  const t = i18nInstance.global.t;
  return [
    {
      name: "sti.pdf.arrivalCity",
      value: dataHead.originConsolidator
    },
    {
      name: "sti.pdf.consolidatorName",
      value: ellipsisString(dataHead.consolidatorName, 21)
    },
    {
      name: "sti.pdf.manifestDate",
      value: formatDate(dataHead.stiDate, "DD MMMM YYYY HH:mm:ss")
    },
    {
      name: "sti.pdf.totalSttPieces",
      value: `${dataHead.totalStt}/${dataHead.totalPiece}`
    },
    {
      name: "sti.pdf.PODSoon",
      value:
        dataHead.statusReturnPOD === 0
          ? String(t("sti.pdf.no"))
          : String(dataHead.statusReturnPOD)
    },
    {
      name: "sti.pdf.RTSSoon",
      value:
        dataHead.statusReturnRTS === 0
          ? String(t("sti.pdf.no"))
          : String(dataHead.statusReturnRTS)
    },
    {
      name: "sti.pdf.HALSoon",
      value:
        dataHead.statusReturnHAL === 0
          ? String(t("sti.pdf.no"))
          : String(dataHead.statusReturnHAL)
    }
  ];
}

export default class Generate extends Vue {
  // get profile account
  get dataProfile() {
    return AccountController.accountData;
  }
  async print(id: number, logo: any) {
    // logo
    MainAppController.showLoading();

    const printManifest = await STIController.getStiManifestDetail({
      id,
      version: "v2",
      print: true
    });
    if (printManifest) {
      const data = STIController.stiManifestData;
      generateManifest(data, logo);
    }
    MainAppController.closeLoading();
  }

  async printSummary(id: number, logo: any) {
    // logo
    MainAppController.showLoading();

    const printManifest = await STIController.getStiManifestDetail({
      id,
      version: "v2",
      print: true
    });
    if (printManifest) {
      const dataHead = STIController.stiManifestData;
      const fields = buildSummaryFields(dataHead);
      generateSummaryManifest(`STI Manifest - ${dataHead.stiId}`, fields, logo);
    }
    MainAppController.closeLoading();
  }

  async printSttNeedSti(id: number, logo: any) {
    // logo
    MainAppController.showLoading();

    const printManifest = await STIController.getDetailSTIReverseScan(id);
    if (printManifest) {
      const data = STIController.STIReverseScanDetailData;
      generateManifestNeedToSti(data, logo);
    }
    MainAppController.closeLoading();
  }

  async printManifestAndSttNeedSti(id: number, logo: any) {
    // logo
    MainAppController.showLoading();

    const printManifest = await STIController.getDetailSTIReverseScan(id);
    if (printManifest) {
      const data = STIController.STIReverseScanDetailData;
      generateManifestAndManifestNeedToSti(data, logo);
    }
    MainAppController.closeLoading();
  }

  // role account user
  get roleAccount() {
    return (
      (this.dataProfile.account_type === "partner"
        ? this.dataProfile.account_type_detail.type
        : this.dataProfile.account_type) || "internal"
    );
  }
}
